import { Typography, Box, Divider } from '@mui/material';
import type { FormDescriptor } from '@finance/contracts';
import { useAppI18n } from '../../i18n/use-app-i18n';
import { formTokens } from './forms/form.tokens.ts';

export interface FormHeaderProps {
  descriptor: FormDescriptor;
}

export function FormHeader({ descriptor }: FormHeaderProps) {
  const { text } = useAppI18n();

  const title = descriptor.titleKey ? text(descriptor.titleKey) : undefined;
  const description = descriptor.descriptionKey ? text(descriptor.descriptionKey) : undefined;

  if (!title && !description) return null;

  return (
    <Box sx={{ mb: formTokens.spacing.sectionGap + 1 }}>
      {title && (
        <Typography
          variant={formTokens.typography.title}
          component="h2"
          sx={{ mb: description ? 1 : 0 }}
        >
          {title}
        </Typography>
      )}
      {description && (
        <Typography variant={formTokens.typography.description} color="text.secondary">
          {description}
        </Typography>
      )}
      <Divider sx={{ mt: 2.5 }} />
    </Box>
  );
}
